(function() {
  // カートクリア処理をまとめた関数
  function clearCartOnPage() {
    if (window.location.pathname === "/pages/select-rf-mg") {
      fetch("/cart/clear.js")
        .then(response => response.json())
        .then(data => console.log("カートがクリアされました", data))
        .catch(error => console.error("カートクリアエラー:", error));
    }
  }

  // ドキュメントの読み込み状況に応じて処理を実行
  if (document.readyState === "loading") {
    // DOM の読み込みが完了していなければイベントリスナーを設定
    document.addEventListener("DOMContentLoaded", clearCartOnPage);
  } else {
    // すでに読み込みが完了している場合は即実行
    clearCartOnPage();
  }
})();
